import axios from "axios";

const url = process.env.REACT_APP_API_URL_KAPAL
const contentType = "application/json"

export default class KapalService {
    //referensi disposisi
    listDisposisi(nmDisposisi, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nmDisposisi !== null) {
            param += '&nmDisposisi=' + nmDisposisi
        }
        return axios.get(url + '/disposisi?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getDisposisiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/disposisi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveDisposisi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/disposisi', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteDisposisiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/disposisi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //referensi jenis dok kapal
    listJenisDokKapal(jenisDokKapal, kelompok, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (jenisDokKapal !== null) {
            param += '&jenisDokKapal=' + jenisDokKapal
        }
        if (kelompok !== null) {
            param += '&kelompok=' + kelompok
        }
        return axios.get(url + '/ref-jenis-dok-kapal?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisDokKapalById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-jenis-dok-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveJenisDokKapal(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ref-jenis-dok-kapal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteJenisDokKapalById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ref-jenis-dok-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //referensi jenis komoditi
    listJenisKomoditi(uraianSearch, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (uraianSearch !== null) {
            param += '&uraianSearch=' + uraianSearch
        }
        return axios.get(url + '/jenis-komoditi?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisKomoditiById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/jenis-komoditi/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //referensi jenis ijin
    listJenisIjinKapal(uraianJenis, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (uraianJenis !== null) {
            param += '&uraianJenis=' + uraianJenis
        }
        return axios.get(url + '/ref-jenis-ijin-kapal?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getJenisIjinKapalById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-jenis-ijin-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveJenisIjinKapal(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ref-jenis-ijin-kapal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteJenisIjinKapalById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ref-jenis-ijin-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //referensi status permohonan
    listRefStatusPermohonanKapal(uraianStatus, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (uraianStatus !== null) {
            param += '&uraianStatus=' + uraianStatus
        }
        return axios.get(url + '/ref-status-kapal?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getRefStatusPermohonanKapalById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-status-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveRefStatusPermohonan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ref-status-kapal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteRefStatusPermohoan(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ref-status-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //master kapal
    listMasterKapal(page, size, namaKapal, kodeTrader = 0) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (namaKapal !== null) {
            param += '&namaKapal=' + namaKapal
        }
        return axios.get(url + '/master-kapal?page=' + page + '&size=' + size + '&kodeTrader=' + kodeTrader + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getMasterKapalById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/master-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveMasterKapal(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/master-kapal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteMasterKapalById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/master-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //ijin kapal
    listIjinKapalAllByIdKapal(idKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ijin-kapal?idKapal=' + idKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listIjinKapalById(idIjinKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ijin-kapal/' + idIjinKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveIjinKapal(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ijin-kapal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteIjinKapal(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ijin-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //transaksi 
    //kapal header
    listKapalHeader(nomorAjuKapal, nmKapal, kdProp, kdKota, kodeUpt, page, size, kodeTrader, kodeStatus) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAjuKapal !== null) {
            param += '&nomorAjuKapal=' + nomorAjuKapal
        }
        if (nmKapal !== null) {
            param += '&namaKapal=' + nmKapal
        }
        if (kdProp !== null) {
            param += '&kdProp=' + kdProp
        }
        if (kdKota !== null) {
            param += '&kdKota=' + kdKota
        }
        if (kodeUpt !== null) {
            param += '&kodeUpt=' + kodeUpt
        }
        if (kodeTrader !== null) {
            param += '&kodeTrader=' + kodeTrader
        }
        if (kodeStatus !== null) {
            param += '&kodeStatus=' + kodeStatus
        }
        return axios.get(url + '/ppm-kapal?page=' + page + '&size=' + size + param + '&sort=updatedDate,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKapalHeaderOnProcess(nomorAjuKapal, nmKapal, kdProp, kdKota, kodeUpt, page, size, kodeTrader) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAjuKapal !== null) {
            param += '&nomorAjuKapal=' + nomorAjuKapal
        }
        if (nmKapal !== null) {
            param += '&namaKapal=' + nmKapal
        }
        if (kdProp !== null) {
            param += '&kdProp=' + kdProp
        }
        if (kdKota !== null) {
            param += '&kdKota=' + kdKota
        }
        if (kodeUpt !== null) {
            param += '&kodeUpt=' + kodeUpt
        }
        if (kodeTrader !== null) {
            param += '&kodeTrader=' + kodeTrader
        }
        return axios.get(url + '/ppm-kapal?page=' + page + '&size=' + size + param + '&kodeStatus=010&kodeStatus=020&kodeStatus=021&kodeStatus=022&kodeStatus=023&kodeStatus=024&kodeStatus=025&kodeStatus=026&kodeStatus=027&sort=updatedDate,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKapalHeaderInspeksi(nomorAjuKapal, nmKapal, kdProp, kdKota, kodeUpt, page, size, kodeTrader) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAjuKapal !== null) {
            param += '&nomorAjuKapal=' + nomorAjuKapal
        }
        if (nmKapal !== null) {
            param += '&namaKapal=' + nmKapal
        }
        if (kdProp !== null) {
            param += '&kdProp=' + kdProp
        }
        if (kdKota !== null) {
            param += '&kdKota=' + kdKota
        }
        if (kodeUpt !== null) {
            param += '&kodeUpt=' + kodeUpt
        }
        if (kodeTrader !== null) {
            param += '&kodeTrader=' + kodeTrader
        }
        return axios.get(url + '/ppm-kapal?page=' + page + '&size=' + size + param + '&kodeStatus=020&kodeStatus=021&kodeStatus=022&kodeStatus=023&kodeStatus=024&kodeStatus=050&kodeStatus=051&kodeStatus=052&sort=updatedDate,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKapalHeaderEvTeknis(nomorAjuKapal, nmKapal, kdProp, kdKota, kodeUpt, page, size, kodeTrader) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAjuKapal !== null) {
            param += '&nomorAjuKapal=' + nomorAjuKapal
        }
        if (nmKapal !== null) {
            param += '&namaKapal=' + nmKapal
        }
        if (kdProp !== null) {
            param += '&kdProp=' + kdProp
        }
        if (kdKota !== null) {
            param += '&kdKota=' + kdKota
        }
        if (kodeUpt !== null) {
            param += '&kodeUpt=' + kodeUpt
        }
        if (kodeTrader !== null) {
            param += '&kodeTrader=' + kodeTrader
        }
        return axios.get(url + '/ppm-kapal?page=' + page + '&size=' + size + param + '&kodeStatus=025&kodeStatus=026&kodeStatus=027&sort=updatedDate,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKapalHeaderReject(nomorAjuKapal, nmKapal, kdProp, kdKota, kodeUpt, page, size, kodeTrader) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAjuKapal !== null) {
            param += '&nomorAjuKapal=' + nomorAjuKapal
        }
        if (nmKapal !== null) {
            param += '&namaKapal=' + nmKapal
        }
        if (kdProp !== null) {
            param += '&kdProp=' + kdProp
        }
        if (kdKota !== null) {
            param += '&kdKota=' + kdKota
        }
        if (kodeUpt !== null) {
            param += '&kodeUpt=' + kodeUpt
        }
        if (kodeTrader !== null) {
            param += '&kodeTrader=' + kodeTrader
        }
        return axios.get(url + '/ppm-kapal?page=' + page + '&size=' + size + param + '&kodeStatus=110&kodeStatus=120&kodeStatus=130&kodeStatus=131&kodeStatus=132&kodeStatus=133&sort=updatedDate,desc', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKapalHeaderById(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveKapalHeader(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteKapalHeader(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppm-kapal/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    copyPermohonan(oldAju, newAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/copy-permohonan/' + oldAju + '/' + newAju, null, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //next seri
    nextSeriKapal(tableName, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/next-seri?tableName=' + tableName + '&nomorAju=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //kapal ikan
    listKapalIkan(nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-ikan?nomorAju=' + nomorAju + '&page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKapalIkanById(kapalIkanPK) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-ikan-by-id', kapalIkanPK, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    saveKapalIkan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-ikan', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteKapalIkanById(kapalIkanPK) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-ikan-delete', kapalIkanPK, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteKapalIkanByAju(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-ikan-delete-by-aju/' + nomorAjuKapal, null, {
            headers: {
                'Authorization': Auth,
            }
        })
    }

    listKapalIkanKomoditi(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-ikan-komoditi/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //kapal dok
    listKapalDokumen(nomorAju, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-dok?nomorAju=' + nomorAju + '&page=' + page + '&size=' + size, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKapalDokumenById(kapalDokPK) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-dok-by-id', kapalDokPK, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    getKapalDokumenByAjuKodeDok(nomorAjuKapal, kodeDokumen) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-dok-by-aju-kodedok?nomorAjuKapal=' + nomorAjuKapal + '&kodeDokumen=' + kodeDokumen, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveKapalDokumen(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-dok', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteKapalDokumenById(kapalDokPK) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-dok-delete', kapalDokPK, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    //kapal status
    listKapalStatus(nomorAju) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-status?nomorAju=' + nomorAju, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveKapalStatus(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-status', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    //sertifikat kapal
    listKapalSertifikat(nomorAjuKapal, nomorSertifikat, namaKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        let param = ''
        if (nomorAjuKapal !== null) {
            param += '&nomorAjuKapal=' + nomorAjuKapal
        }
        if (nomorSertifikat !== null) {
            param += '&nomorSertifikat=' + nomorSertifikat
        }
        if (namaKapal !== null) {
            param += '&namaKapal=' + namaKapal
        }
        return axios.get(url + '/sertifikat-kapal?' + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKapalSertifikatById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/sertifikat-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveKapalSertifikat(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/sertifikat-kapal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deletKapalSertifikatById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/sertifikat-kapal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listKapalSertifikatProduk(idSert, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/sertifikat-kapal-produk/' + idSert + '/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveKapalSertifikatProduk(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/sertifikat-kapal-produk', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    //ref dok wajib
    listDokumenWajib(isOver5Gt, isPembeku) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-dok-wajib?isOver5Gt=' + isOver5Gt + '&isPembeku=' + isPembeku, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //ref kesimpulan
    listKesimpulan(idDisposisi) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-kesimpulan/' + idDisposisi, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getKesimpulanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-kesimpulan-by-id/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //ref checklist
    checklistTipeAll() {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/checklist-tipe-all', {
            headers: {
                'Authorization': Auth
            }
        })
    }

    checklistCek(isOver5Gt, isPembeku) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/checklist-check?isOver5Gt=' + isOver5Gt + '&isPembeku=' + isPembeku, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    checklistTipe(kodeTipe) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/checklist-tipe?kodeTipe=' + kodeTipe, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    checklistKelompok(kodeTipe) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/checklist-kelompok?kodeTipe=' + kodeTipe, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    checklistPersyaratan(kodeKelompok) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/checklist-persyaratan?kodeKelompok=' + kodeKelompok, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    checklistTargetNilai(kodeSyarat) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/checklist-target-nilai?kodeSyarat=' + kodeSyarat, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    checklistParamInspeksi(kodeTipe) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/checklist-param-inspeksi?kodeTipe=' + kodeTipe, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //evaluasi permohonan
    listHasilEvPermohonan(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-ev-permohonan?nomorAjuKapal=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    findHasilEvPermohonan(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-ev-permohonan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveHasilEvPermohonan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hasil-ev-permohonan', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteHasilEvPermohonan(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hasil-ev-permohonan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listHasilEvPermohonanDok(nomorAjuKapal, idEvp) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-ev-permohonan-dok?nomorAjuKapal=' + nomorAjuKapal + '&idEvp=' + idEvp, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    findHasilEvPermohonanDok(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-ev-permohonan-dok/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveHasilEvPermohonanDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/hasil-ev-permohonan-dok', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteHasilEvPermohonanDok(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/hasil-ev-permohonan-dok/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //spt
    getSptByAjuAndNomor(nomorAjuKapal, nomorSpt) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/kapal-spt?nomorAjuKapal=' + nomorAjuKapal + '&nomorSpt=' + nomorSpt, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveSptKapal(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/kapal-spt', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteSptKapal(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/kapal-spt/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //penugasan
    listPenugasanAll(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-penugasan?nomorAjuKapal=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listPenugasanDetilAll(idProses) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-penugasan-detil/' + idProses, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    savePenugasan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-penugasan', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    savePenugasanDetil(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/ppm-kapal-penugasan-detil', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deletePenugasan(idProses) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppm-kapal-penugasan/' + idProses, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deletePenugasanDetil(idProsesDtl) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/ppm-kapal-penugasan-detil/' + idProsesDtl, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getPenugasanByAjuAndIdDisposisi(nomorAjuKapal, idDisposisi) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-penugasan/' + nomorAjuKapal + '/' + idDisposisi, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getFirstPenugasanDetilByIdProses(idProses){
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ppm-kapal-penugasan-detil-first/' + idProses, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //batal inspeksi
    listInspeksiBatal(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-batal?nomorAjuKapal=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    findInspeksiBatal(nomorAjuKapal, noTugas) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-batal-by-aju-notugas?nomorAjuKapal=' + nomorAjuKapal + '&noTugas=' + noTugas, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveInspeksiBatal(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-batal', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteInspeksiBatal(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/inspeksi-batal/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //audit kecukupan
    listAuditKecukupan(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/audit-kecukupan?nomorAjuKapal=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getAuditKecukupanById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/audit-kecukupan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveAuditKecukupan(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/audit-kecukupan', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteAuditKecukupan(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/audit-kecukupan/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listAuditKecukupanDok(idInspeksiAudit) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/audit-kecukupan-dok?idInspeksiAudit=' + idInspeksiAudit, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getAuditKecukupanDokById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/audit-kecukupan-dok/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveAuditKecukupanDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/audit-kecukupan-dok', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteAuditKecukupanDok(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/audit-kecukupan-dok/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //inspeksi
    getInspeksiData(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-data?nomorAjuKapal=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveInspeksi(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-data', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteInspeksi(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/inspeksi-data/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listInspeksiDokByIdInspeksi(idInspeksi) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-data-dok/' + idInspeksi, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getInspeksiDokById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-data-dok-by-id/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveInspeksiDok(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-data-dok', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteInspeksiDok(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/inspeksi-data-dok-delete/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listInspeksiChecklistByIdInspeksi(idInspeksi) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-data-checklist/' + idInspeksi, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getInspeksiChecklistById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-data-checklist-by-id/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveInspeksiChecklist(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-data-checklist', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteInspeksiChecklist(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/inspeksi-data-checklist-delete/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listHasilInspeksi(nomorAjuKapal, kodeTargetNilai, isUnder5Gt) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/hasil-inspeksi?nomorAjuKapal=' + nomorAjuKapal + '&kodeTargetNilai=' + kodeTargetNilai + '&isUnder5GT=' + isUnder5Gt, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getSummaryChecklist(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/summary-inspeksi?nomorAjuKapal=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getSummaryChecklistSA(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/summary-inspeksi-sa?nomorAjuKapal=' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //evaluasi teknis
    listEvaluasiTeknisByIdInspeksi(idInspeksi) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-evaluasi-teknis/' + idInspeksi, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getEvaluasiTeknisById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-evaluasi-teknis-by-id/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveEvaluasiTeknis(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-evaluasi-teknis', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteEvaluasiTeknis(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/inspeksi-evaluasi-teknis/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    deleteEvaluasiTeknisByAju(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-evaluasi-teknis-delete-by-aju/' + nomorAjuKapal, null, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listEvaluasiTeknisProduk(idInspeksiEvaluasi, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-evaluasi-teknis-produk/' + idInspeksiEvaluasi + '/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveEvaluasiTeknisProduk(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-evaluasi-teknis-produk', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteEvaluasiTeknisProduk(idInspeksiEvaluasi, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-evaluasi-teknis-produk/' + idInspeksiEvaluasi + '/' + nomorAjuKapal, null, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisKomoditiEvaluasiTeknis(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-evaluasi-teknis-produk-komoditi/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    //rekom
    listRekomTeknis(idInspeksi) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-rekom-teknis/' + idInspeksi, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getRekomTeknisById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-rekom-teknis-by-id/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveRekomTeknis(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-rekom-teknis', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteRekomTeknisById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/inspeksi-rekom-teknis/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listRekomTeknisProduk(idInspeksiRekom, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-rekom-teknis-produk/' + idInspeksiRekom + '/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveRekomTeknisProduk(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-rekom-teknis-produk', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteRekomTeknisProduk(idInspeksiRekom, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-rekom-teknis-produk/' + idInspeksiRekom + '/' + nomorAjuKapal, null, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisKomoditiRekomTeknis(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-rekom-teknis-produk-komoditi/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }


    //approval
    listApprovalTeknis(idInspeksi) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-approval-teknis/' + idInspeksi, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    getApprovalTeknisById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-approval-teknis-by-id/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveApprovalTeknis(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-approval-teknis', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteApprovalTeknisById(id) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.delete(url + '/inspeksi-approval-teknis/' + id, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listApprovalTeknisProduk(idInspeksiApproval, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-approval-teknis-produk/' + idInspeksiApproval + '/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    saveApprovalTeknisProduk(jsonData) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-approval-teknis-produk', jsonData, {
            headers: {
                'Authorization': Auth,
                'Content-Type': contentType
            }
        })
    }

    deleteApprovalTeknisProduk(idInspeksiApproval, nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.post(url + '/inspeksi-approval-teknis-produk/' + idInspeksiApproval + '/' + nomorAjuKapal, null, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    listJenisKomoditiApprovalTeknis(nomorAjuKapal) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/inspeksi-approval-teknis-produk-komoditi/' + nomorAjuKapal, {
            headers: {
                'Authorization': Auth
            }
        })
    }


    //ref pelabuhan pendaratan
    listPelabuhanPendaratan(kodePropinsi, namaPelabuhan, page, size) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token

        let param = ''
        if (kodePropinsi !== null) {
            param += '&kodePropinsi=' + kodePropinsi
        }
        if (namaPelabuhan !== null) {
            param += '&namaPelabuhan=' + namaPelabuhan
        }
        return axios.get(url + '/ref-pelabuhan-pendaratan?page=' + page + '&size=' + size + param, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    findPelabuhanPendaratanByKode(kode) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/ref-pelabuhan-pendaratan/' + kode, {
            headers: {
                'Authorization': Auth
            }
        })
    }

    viewFileTteByIdAndModul(idSiapmutu, modul) {
        let token = localStorage.getItem("token")
        let Auth = 'Bearer ' + token
        return axios.get(url + '/view-tte-kapal/' + idSiapmutu + '/' + modul, {
            headers: {
                'Authorization': Auth
            }
        })
    }

}